import React, { memo } from 'react';
import { eqProps } from 'ramda';
import { usePortletTranslations } from 'js/components/system/Portlet';
import { Link } from 'js/components/common/Link';
import { Icon } from 'js/components/common/Icon';
import style from './index.scss';

export default memo(({ expanded, onClick }) => {
    const t = usePortletTranslations();

    return (
        <Link href="#" className={style.toggleAllGames} onClick={onClick}>
            {t(`games.${expanded ? 'viewLess' : 'viewMore'}`)}
            <Icon type="showMoreArrow" className={style.icon} />
        </Link>
    );
}, eqProps('expanded'));
